import { useMemo, useRef } from "react";
import ReactQuill, { Quill } from "react-quill";

import "modules/AgreementsDashboard/components/AgreementsModal/components/AgreementsEditor/AgreementsEditor.scss";

import type QuillType from "quill";

const icons = Quill.import("ui/icons");
icons.undo = `<svg viewbox="0 0 18 18">
    <polygon class="ql-fill ql-stroke" points="6 10 4 12 2 10 6 10"></polygon>
    <path class="ql-stroke" d="M8.09,13.91A4.6,4.6,0,0,0,9,14,5,5,0,1,0,4,9"></path>
  </svg>`;
icons.redo = `<svg viewbox="0 0 18 18">
    <polygon class="ql-fill ql-stroke" points="12 10 14 12 16 10 12 10"></polygon>
    <path class="ql-stroke" d="M9.91,13.91A4.6,4.6,0,0,1,9,14a5,5,0,1,1,5-5"></path>
  </svg>`;

type AgreementsEditorProps = {
  value: string;
  onChange: () => void;
};

type QuillWithHistory = QuillType & {
  history?: {
    undo: () => void;
    redo: () => void;
  };
};

const quillFormats = ["bold", "italic", "underline", "strike", "code", "script", "list", "indent", "align", "size", "font", "color", "link", "image", "emoji"];

export const AgreementsEditor = ({ value, onChange }: AgreementsEditorProps) => {
  const quillRef = useRef<QuillWithHistory | null>(null);

  const quillModules = useMemo(
    () => ({
      history: { delay: 200, maxStack: 500, userOnly: true },
      toolbar: {
        container: [
          ["bold", "italic", "underline", "strike", "code"],
          [{ script: "sub" }, { script: "super" }],
          [{ size: [] }, { font: [] }],
          [{ color: [] }],
          [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }, { align: [] }],
          ["link", "image"],
          ["undo", "redo"],
          ["clean"]
        ],
        handlers: {
          undo: () => quillRef.current?.history?.undo(),
          redo: () => quillRef.current?.history?.redo()
        }
      },
      clipboard: {
        matchVisual: false
      }
    }),
    []
  );

  return (
    <div className="AgreementsEditor">
      <ReactQuill
        ref={el => {
          if (el) quillRef.current = el.getEditor();
        }}
        theme="snow"
        value={value || ""}
        onChange={onChange}
        modules={quillModules}
        formats={quillFormats}
        style={{ height: "400px", marginBottom: "40px" }}
      />
    </div>
  );
};
